import { useEffect } from 'react'
import {
    listenForPullDownRefresh,
    removePullDownListener,
} from 'utils/eventEmitter'

const useRefresh = (
    refetch: () => void,
    remove: () => void,
    enabled: boolean = true,
) => {
    useEffect(() => {
        if (!enabled) return

        const handlePullDownRefresh = () => {
            remove()
            // refetch() may return a promise (e.g. from react-query).
            // Catch any rejection to prevent unhandled promise rejections.
            Promise.resolve(refetch()).catch(() => {
                // Error is already handled by react-query and logged in fetchGeneralData
            })
        }
        listenForPullDownRefresh(handlePullDownRefresh)

        return () => removePullDownListener(handlePullDownRefresh)
    }, [refetch, remove, enabled])
}

export default useRefresh
